import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class KlingerTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const klingerValue = currentItem && yAccessor(currentItem);

    const klinger =
      (klingerValue && klingerValue.macd && displayFormat(klingerValue.macd)) ||
      "n/a";
    const signal =
      (klingerValue &&
        klingerValue.signal &&
        displayFormat(klingerValue.signal)) ||
      "n/a";
    const divergence =
      (klingerValue &&
        klingerValue.divergence &&
        displayFormat(klingerValue.divergence)) ||
      "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-klinger"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>Klinger (</ToolTipTSpanLabel>
          <tspan fill={appearance.stroke.macd}>{options.shortCycle}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={appearance.stroke.macd}>{options.longCycle}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={appearance.stroke.macd}>{klinger}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Signal (</ToolTipTSpanLabel>
          <tspan fill={appearance.stroke.signal}>{options.signalPeriods}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={appearance.stroke.signal}>{signal}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Divergence: </ToolTipTSpanLabel>
          <tspan fill={appearance.fill.divergence}>{divergence}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

KlingerTooltip.propTypes = {
  className: PropTypes.string,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  displayValuesFor: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  appearance: PropTypes.shape({
    stroke: PropTypes.shape({
      macd: PropTypes.string.isRequired,
      signal: PropTypes.string.isRequired,
    }).isRequired,
    fill: PropTypes.shape({
      divergence: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  options: PropTypes.shape({
    shortCycle: PropTypes.number.isRequired,
    longCycle: PropTypes.number.isRequired,
    signalPeriods: PropTypes.number.isRequired,
  }).isRequired,
  labelFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
};

KlingerTooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-klinger-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
};

export default KlingerTooltip;
